import type { FC } from 'react';
import { PapiBadge, PapiUser } from '@wix/da-papi-types';
import Badges from './Badges';
import BadgeActivity from './BadgeActivity';
import { BadgeActivityItem } from '../../../../types/badge';
import s from './MyBadges.scss';

export interface Props {
  className?: string;
  badges: PapiBadge[];
  badgeActivity: BadgeActivityItem[];
  totalSent: number;
  totalReceived: number;
  isOwner: boolean;
  profileOwnerUser: PapiUser;
}

const MyBadges: FC<Props> = ({
  badges,
  badgeActivity,
  totalSent,
  totalReceived,
  isOwner,
  profileOwnerUser,
}) => {
  const widthBreakpoints = [640, 800];
  return (
    <>
      <Badges
        className={s['section']}
        items={badges}
        widthBreakpoints={widthBreakpoints}
        profileOwnerUser={profileOwnerUser}
      />
      <BadgeActivity
        className={s['activities']}
        totalSent={totalSent}
        totalReceived={totalReceived}
        items={badgeActivity}
        isOwner={isOwner}
        ownerUsername={profileOwnerUser.username}
      />
    </>
  );
};
MyBadges.displayName = 'MyBadges';

export default MyBadges;
